import { BaseComponent } from '../../base-component';
import { openSheet } from '../../_common/client/nexus-interfaces/product-room-fit-sheet';

export class ProductRoomFitSheetComponent extends BaseComponent {
    public rootSelector = '.js_pdp_product-room-fit-sheet';

    public async init(): Promise<void> {
        const { open } = await import('./product-room-fit-sheet');
        openSheet.assignFunction((variationId, debug) => open(variationId, debug));
    }
}
